import React from "react";

interface CardProps {
  children: React.ReactNode;
  className?: string;
}

const Card: React.FC<CardProps> = ({ children, className = "" }) => {
  return (
    <div className={`bg-white border rounded-xl p-4 shadow-sm ${className}`}>
      {children}
    </div>
  );
};

export default Card;
